<template>
  <div class="w-full h-full fixed block top-0 left-0 bg-white opacity-75 z-50" v-if="loading">
    <div class="flex h-screen">
      <div class="m-auto">
        <div class="lds-roller justify-center content-center items-center ">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  computed: {
    loading () {
      return this.$store.state.loader
    }
  }
}
</script>

<style>
</style>
